import React from 'react'
import styled, { css } from 'styled-components'
import { InlineLoader } from '../'
import CustomScroll from 'react-custom-scroll'
import '../../styles/custom_scroll.css'

const Container = styled.div`
  background: #fff;
  border: 1px solid #eeeeee;
  border-radius: 5px;
  width: 100%;
  display: flex;
  flex-flow: column;
  margin-bottom: 30px;
`

const Title = styled.div`
  border-bottom: 1px solid #eeeeee;
  font-size: 16px;
  padding: 15px 20px;
  border-radius: 4px 4px 0 0;
  .fa {
    color: ${props => (props.blue ? '#fff' : 'blue')};
    font-size: 18px;
  }
  ${props =>
    props.blue &&
    css`
      background: ${'blue'};
      color: #fff;
    `}
`
const Content = styled.div`
  padding: 20px;
  height: ${props => (props.height ? props.height : 'auto')};
`
const ContentWrapper = styled.div`
  height: 100%;
  position: relative;
  width: 100%;
  .no-content {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    width: 100%;
    color: #989898;
    font-size: 16px;
  }
`

const Footer = styled.div`
  border-top: 1px solid #eeeeee;
  padding: 15px;
`

const Panel = ({
  title,
  children,
  footer,
  buttons,
  className,
  blue,
  height
}) => {
  // Filter out null array values
  if (children && Array.isArray(children)) {
    children = children.filter(e => e)
  }

  return (
    <Container className={className}>
      <Title className="clearfix" blue={blue}>
        <div className="pull-left">{title || 'Loading...'}</div>
        <div className="pull-right">{buttons}</div>
      </Title>

      <Content height={height}>
        <If condition={!children || children.length === 0}>
          <InlineLoader />
        </If>
        <If condition={children}>
          <If condition={height}>
            <CustomScroll heightRelativeToParent="100%" allowOuterScroll={true}>
              <ContentWrapper>{children}</ContentWrapper>
            </CustomScroll>
          </If>

          <If condition={!height}>
            <ContentWrapper>{children}</ContentWrapper>
          </If>
        </If>
      </Content>
      <If condition={footer}>
        <Footer>{footer}</Footer>
      </If>
    </Container>
  )
}

export default Panel



// WEBPACK FOOTER //
// ./src/components/Panel/index.js